<template>
    <!--弹窗-->
    <el-dialog
        width="90%"
        :title="pageType ==1 ? '物流发票生成' : pageType ==2 ? '物流发票查看' : '物流发票修改'"
        top="3vh"
        :visible.sync="visible"
        :before-close="handleClose"
    >
        <el-form ref="formData" :inline="true" class="query-form" size="mini" :rules="rules" :model="formData">

            <el-form-item label="FBA入仓号：" class="query-form-item" prop="warehouse_number">
                <el-input v-model="formData.warehouse_number" placeholder="请输入FBA入仓号" :disabled="isPreview"></el-input>
            </el-form-item>

            <el-form-item label="Reference ID：" class="query-form-item" prop="reference_id">
                <el-input v-model="formData.reference_id" placeholder="请输入Reference ID"
                          :disabled="isPreview"></el-input>
            </el-form-item>

            <el-form-item label="仓库代码：" class="query-form-item" prop="logistics_address_id">
                <el-select v-model="formData.logistics_address_id" placeholder="请选择" size="mini" filterable
                           :disabled="isPreview" style="width: 200px;">
                    <el-option :label="item.warehouse_code" :value="item.id"
                               v-for="item in addressList"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="编号：" class="query-form-item">
                <el-input v-model="formData.number" placeholder="请输入编号" :disabled="isPreview"></el-input>
            </el-form-item>

            <el-button @click="openBox(1)" type="success" size="mini" v-show="!isPreview">添加箱子</el-button>
            <el-button @click="clearAllBox" type="danger" size="mini" v-show="!isPreview">全部清空</el-button>

        </el-form>

        <el-table
            :data="formData.box_datas"
            size="mini"
            ref="multipleTable"
            class="table_content etyme_index"
            :expand-row-keys="expands"
            @expand-change="clickRowHandle"
            row-class-name="success-row"
            :row-key="getRowKeys"
            border
        >
            <el-table-column type="expand">
                <template slot-scope="scope">
                    <productTable ref="productTableDom" :dataRow="scope.row && scope.row.items ? scope.row.items : []"
                                  :asinList="asinList" :boxIndex="scope.$index" :isPreview="isPreview"
                                  @updateBoxInner="addBoxInner"/>
                </template>
            </el-table-column>
            <el-table-column label="箱子规格" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.specification }}</div>
                </template>
            </el-table-column>
            <el-table-column label="箱数" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.box_number }}</div>
                </template>
            </el-table-column>
            <el-table-column label="箱重" align="center">
                <template slot-scope="scope">
                    <div>{{ scope.row.box_weight }}</div>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="374" align="center" v-if="!isPreview">
                <template slot-scope="scope">
                    <div @click.stop>
                        <el-button style="margin: 5px 0 5px 10px" size="mini" type="success"
                                   @click.native="addBoxInner(1, null, scope.$index)">
                            添加箱子内产品
                        </el-button>

                        <el-button style="margin: 5px 0 5px 10px" size="mini" type="primary"
                                   @click.native="openBox(2, scope.row, scope.$index)">
                            修改箱子信息
                        </el-button>

                        <el-button style="margin: 5px 0 5px 10px" size="mini" type="danger"
                                   @click.native="deleteBox(2, scope.row, scope.$index)">
                            删除箱子
                        </el-button>
                    </div>
                </template>
            </el-table-column>
        </el-table>


        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose" type="primary" size="mini">关 闭</el-button>
            <el-button @click="createFunc" type="success" size="mini" v-show="pageType==1">生 成</el-button>
            <el-button @click="updateFunc" type="success" size="mini" v-show="pageType==3">修 改</el-button>
        </span>

        <boxModal ref="boxModalDom" @close-callback="boxCloseCallBack"/>

        <productModal ref="productModalDom" @close-callback="closeCllback" :asinList="asinList"
                      @addAsinCallBack="queryAsinList"/>

    </el-dialog>
</template>
<script>
    import * as api from '@/api/advAnalys/advAnalys.js'
    import boxModal from './boxModal'
    import productModal from './productModal'
    import productTable from './productTable'
    export default {
        components: {productTable, boxModal, productModal},
        data() {
            return {
                expands: [],
                pageType: 1, // 1add 2preview 3update
                editSubIndex: 0,
                prodIndex: 0,
                asinList: [],
                addressList: [],
                rules: {
                    logistics_address_id: [
                        {
                            required: true,
                            message: '请选择物流地址',
                            trigger: 'blur'
                        },
                    ],
                    warehouse_number: [
                        {
                            required: true,
                            message: '请输入FBA入仓号',
                            trigger: 'blur'
                        },
                    ],
                    reference_id: [
                        {
                            required: true,
                            message: '请输入Reference ID',
                            trigger: 'blur'
                        },
                    ],
                },
                visible: false,
                isPreview: false,
                formData: {
                    number: undefined,
                    logistics_address_id: undefined,
                    warehouse_number: undefined,
                    reference_id: undefined,
                    box_datas: [],
                },
                childInfoVisible: false,
                previewInfo: {},
            }
        },
        watch: {
            'formData': {
                handler(val) {
                    if (this.pageType == 1) {
                        window.sessionStorage.setItem('set_addInvoice', JSON.stringify(val))
                    }
                },
                deep: true,
            }
        },
        created() {
            this.queryAddressList()
            this.queryAsinList()
        },
        methods: {
            getRowKeys(row) {
                return JSON.stringify(row)
            },
            clickRowHandle(row, expanded) {
                const tempItem = JSON.stringify(row)
                if (this.expands.includes(tempItem)) {
                    this.expands = this.expands.filter(val => val !== tempItem)
                } else {
                    this.expands.push(tempItem)
                }
            },
            // 添加箱子
            openBox(type, data, index) {
                if (type == 2) {
                    data = JSON.parse(JSON.stringify(data))
                    this.editSubIndex = index
                }
                this.$refs.boxModalDom.openModal(type, data)
            },
            clearAllBox() {
                this.$confirm(`确定清空所有信息吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.initFormData()
                }).catch(() => {
                })
            },
            deleteBox(type, data, index) {
                this.$confirm(`确定删除此箱子吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$delete(this.formData.box_datas, index)
                }).catch(() => {
                })
            },
            // 添加箱子内产品
            addBoxInner(type, data, index, prodIndex) {
                this.editSubIndex = index
                if (type == 2) {
                    this.prodIndex = prodIndex
                    data = JSON.parse(JSON.stringify(data))
                }
                this.$refs.productModalDom.openModal(type, data)
            },
            queryAddressList() {
                api.logistics_address_lists().then((res) => {
                    if (res.code == 0) {
                        this.addressList = res.data || []
                    }
                })
            },
            queryAsinList() {
                api.logistics_asin_lists().then((res) => {
                    if (res.code == 0) {
                        this.asinList = res.data || []
                    }
                })
            },
            boxCloseCallBack(obj) {
                if (obj.flag) {
                    if (obj.pageType == 1) {
                        this.formData.box_datas.push(obj.data)
                    } else if (obj.pageType == 2) {
                        this.$set(this.formData.box_datas, this.editSubIndex, obj.data)
                    }
                }
            },

            openModal(type, data) {
                this.pageType = type
                if (type == 1) {
                    const cacheData = JSON.parse(window.sessionStorage.getItem('set_addInvoice'))
                    if (cacheData && (cacheData.box_datas.length > 0 || cacheData.logistics_address_id || cacheData.reference_id || cacheData.warehouse_number)) {
                        this.formData = cacheData
                    } else {
                        this.initFormData()
                    }
                } else {
                    this.formData = data
                    if (type == 2) {
                        this.isPreview = true
                    }
                }
                this.visible = true
            },
            closeCllback(obj) {
                if (obj.flag) {
                    if (obj.pageType == 1) {
                        this.formData.box_datas[this.editSubIndex].items.push(obj.data)
                    } else if (obj.pageType == 2) {
                        this.$set(this.formData.box_datas[this.editSubIndex].items, this.prodIndex, obj.data)
                    }
                }
            },
            showInfo(title, info) {
                this.previewInfo = {title, info}
                this.childInfoVisible = true
            },
            showModal(data) {
                this.formData = data
                this.visible = true
            },
            // 关闭弹窗
            handleClose(flag = false) {
                this.visible = false
                this.isPreview = false
                this.$emit('close-callback', flag)
            },
            createFunc() {
                this.$refs['formData'].validate(valid => {
                    if (valid) {
                        api.logistics_invoice_create(this.formData).then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message({message: '生成成功', type: 'success'})
                                this.initFormData()
                                this.handleClose(true)
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        }).catch(() => {
                            this.loading = false
                            this.$message({
                                type: 'error',
                                message: '网络出现问题，请刷新页面！'
                            })
                        })
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },
            updateFunc() {
                this.$refs['formData'].validate(valid => {
                    if (valid) {
                        api.logistics_invoice_update_field(this.formData).then(res => {
                            this.loading = false
                            if (res.code === 0) {
                                this.$message({message: '修改成功', type: 'success'})
                                this.initFormData()
                                this.handleClose(true)
                            } else {
                                this.$message({type: 'error', message: res.message})
                            }
                        }).catch(() => {
                            this.loading = false
                            this.$message({
                                type: 'error',
                                message: '网络出现问题，请刷新页面！'
                            })
                        })
                    } else {
                        this.loading = false
                        this.$message({
                            type: 'error',
                            message: '请填写相应内容！'
                        })
                    }
                })
            },
            initFormData() {
                this.formData = {
                    logistics_address_id: undefined,
                    number: '',
                    warehouse_number: '',
                    reference_id: '',
                    box_datas: []
                }
            }
        }
    }
</script>
<style type="text/scss" lang="scss">
    .el-table .success-row {
        background: #f0f9eb;
    }
</style>

